import {createStackNavigator} from '@react-navigation/stack';
import React from 'react';
import {Platform} from 'react-native';
import * as PortaOut from '../scenes/PortaOut';
import theme from '../theme-config';

const Stack = createStackNavigator();

export const PortaOutStack = () => {
  return (
    <Stack.Navigator
      initialRouteName="refused"
      screenOptions={Platform.select({
        web: {
          headerMode: 'none',
          cardStyle: {
            backgroundColor: theme.backgroundColor,
          },
        },
        default: {
          headerMode: 'none',
        },
      })}>
      <Stack.Screen name="accepted" component={PortaOut.Accepted} />
      <Stack.Screen name="refused" component={PortaOut.Refused} />
    </Stack.Navigator>
  );
};
